import { useTranslation } from '../../../context/translationContext';
import { UserTaskState, UserTaskStateTranslated } from '../../../types/UserTask';
import { ColDataType, TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'name',
    name: 'page.user-task.col-name',
  },
  {
    accessor: 'state',
    name: 'page.user-task.col-state',
    translateEnum: UserTaskStateTranslated,
    cellRenderer(e) {
      return getTaskStatusBtn(e.state);
    },
  },
  {
    accessor: 'responsibleUser',
    name: 'page.user-task.col-responsible-user',
    innerAccesor: 'fullName',
    hideFilter: true,
    cellRenderer(e) {
      return e?.responsibleUser?.fullName;
    },
  },
  {
    accessor: 'description',
    name: 'page.user-task.col-description',
  },
  {
    accessor: 'createdByUserId',
    name: 'page.user-task.col-created-by-user',
    hideFilter: true,
  },
  {
    accessor: 'created',
    name: 'page.user-task.col-created',
    dataType: ColDataType.DATE,
    hideFilter: true,
  },
  {
    accessor: 'updatedByUserId',
    name: 'page.user-task.col-updated-by-user',
    hideFilter: true,
  },
  {
    accessor: 'updated',
    name: 'page.user-task.col-updated',
    dataType: ColDataType.DATE,
    hideFilter: true,
  },
];

/**
 * Function for generating status indicators with translated name
 * @param status
 */
export const getTaskStatusBtn = (status: UserTaskState) => {
  const { t } = useTranslation();
  const baseClass = `inline-block rounded-full border-2 border-primary px-3 pb-[3px] pt-1 text-xs font-medium leading-normal transition duration-150 ease-in-out hover:border-primary-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-primary-600 focus:border-primary-600 focus:text-primary-600 focus:outline-none focus:ring-0 active:border-primary-700 active:text-primary-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10`;
  let itemClass = ``;
  switch (status) {
    case UserTaskState.CANCELED:
      itemClass = `border border-red-500 text-red-500`;
      break;
    case UserTaskState.CREATED:
      itemClass = `border border-yellow-500 text-yellow-500`;
      break;
    case UserTaskState.IN_PROGRESS:
      itemClass = `border border-blue-500 text-blue-500`;
      break;
    case UserTaskState.COMPLETED:
      itemClass = `border border-green-500 text-green-500`;
      break;
  }
  return (
    <span className={`${itemClass} ${baseClass} w-min-max`}>
      {t(UserTaskStateTranslated[status])}
    </span>
  );
};
